<template>
  <Toast :close-tip="false" class="ruleToast" :close-event="closeEvent">
    <img
      style="margin-top: -5px;"
      src="@/assets/img/regular-desc.png"
      srcset="
        @/assets/img/regular-desc@2x.png 2x,
        @/assets/img/regular-desc@3x.png 3x
      "
    />
    <div class="content-box">
      <p class="rule1">一. 活动规则</p>
      <p v-if="other.modelIds === -4" class="ruleDesc">
        1.领取方式：品牌会员用户选择1张优惠券后，邀请好友成为品牌会员，好友成为品牌会员即为助力成功，当达到指定数量后可以直接获得当前优惠券；为您助力的好友也可在活动页获得1张子券；<br />
        2.参与次数：用户在同一活动，活动期内最多只能领取1张优惠券；<br />
        3.活动时间：需要在页面提示领取时间内邀请好友成为品牌会员助力并领取，超过时间未分享完成将不能领取；领取时间内可能出现因优惠券发放光导致活动终止无法领取；<br />
        4.优惠券使用：可以在活动页面点击“去使用”也可进入“京东app-个人中心-优惠券”使用；<br />
        5.商品价格：活动期间价格出现变化可能导致本页面更新不及时，请以购物车及结算价格为准。
      </p>
      <p v-else class="ruleDesc">
        1、领取方式:用户选择1张优惠券后，邀请好友领取，当达到指定数量后可以直接获得当前优惠券；好友在活动页可直接点击领取；<br />
        2.参与次数：用户在同一活动，活动期内最多只能领取1张优惠券；<br />
        3.活动时间：需要在页面提示领取时间内邀请好友并领取，超过时间未分享完成将不能领取；领取时间内可能出现因优惠券发放光导致活动终止无法领取；<br />
        4.优惠券使用：可以在活动页面点击“去使用”也可进入“京东app-个人中心-优惠券”使用； <br />
        5.商品价格：活动期间价格出现变化可能导致本页面更新不及时，请以购物车及结算价格为准。
      </p>
    </div>
    <p class="btn" @click="close">我知道了</p>
  </Toast>
</template>

<script>
import Toast from "./../VueToast";
export default {
  name: "toast",
  props: {
    closeEvent: Function,
    other: {
      type: Object,
      default: function() { return {} }
    }
  },
  components: {
    Toast
  },
  methods: {
    close() {
      this.closeEvent();
    }
  }
};
</script>

<style lang="scss" scoped>
.ruleToast {
  .toast__content {
    height: auto;
  }
  .head {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #333333;
    text-align: justify;
    margin: 10px 0 15px;
  }
  .rule1 {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #d43124;
    margin: 0 0 10px;
    text-align: justify;
    line-height: 14px;
  }
  .ruleDesc {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #2a2a2a;
    margin: 0 0 10px;
    line-height: 18px;
    text-align: justify;
  }
  .btn {
    height: 35px;
    width: 120px;
    margin: 20px auto 0;
    line-height: 34px;
    background: -webkit-linear-gradient(0deg, #f82111 2%, #ff7314 100%);
    background: -o-linear-gradient(0deg, #f82111 2%, #ff7314 100%);
    background: -moz-linear-gradient(0deg, #f82111 2%, #ff7314 100%);
    background: -ms-linear-gradient(0deg, #f82111 2%, #ff7314 100%);
    background: linear-gradient(0deg, #f82111 2%, #ff7314 100%);
    border-radius: 4px;
    border-radius: 100px;
    color: #fff;
  }
}
</style>
